import { isValidEmailAddress, fadeOutNotifications } from '../functions';
import Swal from 'sweetalert2';

$(document).ready(function() {

	const sliderSearchWidget = {
		isLoading: false,
        init() {
			$(document).on('click', '#slider-pickup-location-trigger', this, this.showPickupLocations);
            $(document).on('click', '#slider-return-location-trigger', this, this.showReturnLocations);
			$(document).on('click', '.slider-search-widget-select-pickup-location', this, this.selectPickupLocation);
            $(document).on('click', '.slider-search-widget-select-return-location', this, this.selectReturnLocation);
			$(document).on('change', '#slider-return_to_other_location', this, this.returnToOtherLocation);
            $(document).on('click', '#slider-search-calendar-trigger', this, this.showCalendar);
            $(document).on('click', '.close-calendar', this, this.closeCalendar);
			$(document).on('click', '.check-availability-btn', this, this.checkAvailability);

			/*window.addEventListener('click', function(e){
		        if (document.getElementById('calendar-wrapper')) {
		            if (document.getElementById('calendar-wrapper').contains(e.target)){
		                //console.log('Clicked in box');
		            } else{
		                if(e.target.id != 'slider-search-calendar-trigger') {
		                    //console.log('Clicked outside the box');
		                    $('#calendar-wrapper').addClass('hidden');
		                }
		            }
		        }

		        if(document.getElementById('slider-pickup-locations-wrapper')) {
		            if (document.getElementById('slider-pickup-locations-wrapper').contains(e.target)){
		                //console.log('Clicked in box');
		            } else{
		                if(e.target.id != 'slider-pickup-location-trigger') {
		                    //console.log('Clicked outside the box');
		                    $('#slider-pickup-locations-wrapper').addClass('hidden');
		                }
		            }
		        }

		        if(document.getElementById('slider-return-locations-wrapper')) {
		            if (document.getElementById('slider-return-locations-wrapper').contains(e.target)){
		                //console.log('Clicked in box');
		            } else{
		                if(e.target.id != 'slider-return-location-trigger') {
		                    //console.log('Clicked outside the box');
		                    $('#slider-return-locations-wrapper').addClass('hidden');
		                }
		            }
		        }
			});

			$('#calendar-place').daterangepicker({
		        alwaysShowCalendars: true,
		        minDate: moment().add(1, 'days'),
		        // startDate: moment().add(1, 'days'),
		        // endDate: moment().add(3, 'days'),
		        autoApply: true,
		        autoUpdateInput: false,
		        locale: {
		            format: 'DD/MM/YYYY'
		        }
		    });

			$('#calendar-place').on('apply.daterangepicker', function(ev, picker) {
		        var startDate = picker.startDate;
		        var endDate = picker.endDate;
		        $('#date-from').val(startDate.format('DD/MM/YYYY'));
		        $('#date-to').val(endDate.format('DD/MM/YYYY'));

		        $('#date-from-text').html(startDate.format('dddd, D MMM'));
		        $('#date-to-text').html(endDate.format('dddd, D MMM'));

		        $('#slider-search-calendar-trigger').html(startDate.format('ddd, D MMM') + ' | ' +endDate.format('ddd, D MMM'));
		    });*/
		},
		returnToOtherLocation(event) {
			const _this = event.data;

			if ($(this).is(":checked")) {
		        $('#slider-return-location-cointainer').show();
		    } else {
		        $('#slider-return-location-cointainer').hide();
		    }
		},
		showPickupLocations(event) {
			const _this = event.data;
			event.preventDefault();

			$('#slider-pickup-locations-wrapper').toggleClass('hidden');
		},
		showReturnLocations(event) {
			const _this = event.data;
			event.preventDefault();

			$('#slider-return-locations-wrapper').toggleClass('hidden');
		},
		selectPickupLocation(event) {
			const _this = event.data;
			event.preventDefault();

			var code = $(this).data('code');
			var name = $(this).data('name');
	        if (!code) { alert('Invalid Location!'); return value; }

	        $('#pickup_location').val(code);
	        $('#slider-pickup-location-trigger').html(name);

	        $('#slider-pickup-locations-wrapper').addClass('hidden');

		},
		selectReturnLocation(event) {
			const _this = event.data;
			event.preventDefault();

			var code = $(this).data('code');
			var name = $(this).data('name');
	        if (!code) { alert('Invalid Location!'); return value; }

	        $('#return_location').val(code);
	        $('#slider-return-location-trigger').html(name);

	        $('#slider-return-locations-wrapper').addClass('hidden');
		},
		closeCalendar(event) {
			const _this = event.data;
			event.preventDefault();

			let type = $(this).data('type');
			if (type == '1') {
				if ($('#pickup_location').val() != '' &&
					$('#date-from').val() != '' &&
					$('#date-to').val() != '' &&
					$('#from-time option:selected').val() != '' &&
					$('#to-time option:selected').val() != '' &&
					(!$('#slider-return_to_other_location').is(':checked') || $('#return_location').val() != '')) {

					let url = $(this).data('url');
					if (url != '') {
						let genUrl = '?pl=' + $('#pickup_location').val();
						if ($('#slider-return_to_other_location').is(':checked')) {
							genUrl += '&rol=1';
							genUrl += '&rl=' + $('#return_location').val();
						} else {
							genUrl += '&rl=' + $('#pickup_location').val();
						}
						genUrl += '&pd=' + $('#date-from').val() + '-' + $('#from-time option:selected').val();
						genUrl += '&rd=' + $('#date-to').val() + '-' + $('#to-time option:selected').val();
						if ($('#age-25-70').is(':checked')) {
							genUrl += '&age_25_70=1';
						}
						if ($('#travel-abroad').is(':checked')) {
							genUrl += '&ta=1';
						}
						if ($('#pet-friendly').is(':checked')) {
							genUrl += '&pf=1';
						}

						//window.location = url + genUrl;
					}
				}
			}

			$('#calendar-wrapper').addClass('hidden');
        	window.scrollTo(0, 0);
		},
		showCalendar(event) {
			const _this = event.data;
			event.preventDefault();
			console.log($('#calendar-wrapper'));
			$('#calendar-wrapper').removeClass('hidden');
        	$('.daterangepicker').css("display", "block");
		},
		checkAvailability(event) {
			const _this = event.data;
			let url = $(this).data('url');
			if (!url || url == '' || url == null) {
				console.error('Invalid URL!');
				return false;
			}

			if ($('#pickup_location').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#pickup_location').data('alert')
				});
				return;
			}
			if ($('#slider-return_to_other_location').is(':checked')) {
				if ($('#return_location').val() == '') {
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: $('#return_location').data('alert')
					})
					return;
				}
			}
			if ($('#date-from').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#date-from').data('alert')
				});
	            return false;
	        }
	        if ($('#date-to').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#date-to').data('alert')
				});
	            return false;
	        }
	        if ($('#from-time option:selected').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#from-time').data('alert')
				});
	            return false;
	        }
	        if ($('#to-time option:selected').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#to-time').data('alert')
				});
	            return false;
	        }

			let genUrl = '?pl=' + $('#pickup_location').val();
			if ($('#slider-return_to_other_location').is(':checked')) {
				genUrl += '&rol=1';
				genUrl += '&rl=' + $('#return_location').val();
			} else {
				genUrl += '&rl=' + $('#pickup_location').val();
			}
			genUrl += '&pd=' + $('#date-from').val() + '-' + $('#from-time option:selected').val();
			genUrl += '&rd=' + $('#date-to').val() + '-' + $('#to-time option:selected').val();
			if ($('#age-25-70').is(':checked')) {
				genUrl += '&age_25_70=1';
			}
			if ($('#travel-abroad').is(':checked')) {
				genUrl += '&ta=1';
			}
			if ($('#pet-friendly').is(':checked')) {
				genUrl += '&pf=1';
			}

			window.location = url + genUrl + '#offers';
		}
	}

	if ($('.search-widget-lp').length) {
        sliderSearchWidget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/slider-search-widget.js